import api from ".";
import { IOption } from "../types/options";
import cookiesModifier from "../utils/cookies";

export const createOption = async (data: IOption) => {
    const url = `options`;
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.post(url, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateOption = async (data: IOption) => {
    try {
        const { id, ...payload } = data;
        const url = `options/${id}`;
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.patch(url, payload);

        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteOption = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`options/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const reorderOption = async (payload: { id: number, action: string }) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    const { id, action } = payload;

    try {
        const res = await api.patch(`options/reorder/${id}/${action}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}